import React from "react";
import Html from "./html";
import { Provider } from "./provider";

const OngoingJobs = () => {
    return (
        <Provider>
            <Html/>
        </Provider>
    );
}

export default OngoingJobs;